function blockInvalidCharForNumberInput(e: React.KeyboardEvent<HTMLInputElement>) {
  const invalidChars = ['-', '+', 'e', 'E'];
  if (invalidChars.includes(e.key)) {
    e.preventDefault();
  }
}

export { blockInvalidCharForNumberInput };